declare const window: (typeof globalThis)['window'] & {
  OnetrustActiveGroups?: string;
};

export enum CookieTypes {
  necessary = 'C0001',
  performance = 'C0002',
  functional = 'C0003',
  targeting = 'C0004',
  socialMedia = 'C0005',
}

export type Consents = {
  necessary: boolean;
  performance: boolean;
  functional: boolean;
  targeting: boolean;
  socialMedia: boolean;
};

const defaultConsents: Consents = {
  necessary: false,
  performance: false,
  functional: false,
  targeting: false,
  socialMedia: false,
};

/**
 * Returns null before OneTrust has loaded.
 */
export function getActiveOneTrustGroups() {
  return window.OnetrustActiveGroups ?? null;
}

export function parseConsents(groups: string) {
  const consents: Consents = { ...defaultConsents };
  for (const key of Object.keys(defaultConsents) as Array<
    keyof typeof defaultConsents
  >) {
    consents[key] = !!groups.includes(CookieTypes[key]);
  }

  return consents;
}

const CONSENT_CHANGED_EVENT = 'OptanonConsentChanged';

export function addOneTrustConsentChangedListener(listener: () => void) {
  window.addEventListener(CONSENT_CHANGED_EVENT, listener);
}

export function removeOneTrustConsentChangedListener(listener: () => void) {
  window.removeEventListener(CONSENT_CHANGED_EVENT, listener);
}
